<template>
  <div class="cb-setup-test-1">
    <div class="cb-setup-test-1__body">
      <h1 class="cb-heading-4" tabindex="-1" ref="title">Trigger the alarm</h1>
      <p class="cb-body-1">
        Now that your system is armed, trigger a test alarm by opening a
        protected door or window.
        <strong>The alarm will need to sound for at least 60 seconds</strong>
        while we test the signal.
      </p>
      <p class="cb-body-1 cb-setup-test-1__body__warning">
        <strong>Caution:</strong> Your alarm siren will be loud
      </p>
    </div>
    <div class="cb-setup-test-1__footer">
      <div class="cb-setup-test-1__footer__divider"></div>
      <div class="cb-setup-test-1__footer__button-container">
        <button @click="handleGoBack" class="cb-button cb-button--outline-blue">
          Go Back
        </button>
        <button
          @click="handleGoBack"
          aria-label="Go Back"
          class="cb-setup-test-1__footer__back-button"
        >
          <img alt src="../assets/icons/back-arrow-blue.svg" />
        </button>
        <cb-button
          type="button"
          @click="handleStartTest"
          :loading="loading"
          :paddingLeft="true"
          >I Triggered My Alarm</cb-button
        >
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag */
import { mapActions, mapMutations, mapState } from 'vuex';
import Button from './shared/Button.vue';

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      isModalOpen: (state) => state.modal.isOpen,
    }),
  },
  mounted() {
    this.$refs.title.focus();
    document.title = 'CellBridge - Trigger the alarm';
  },
  methods: {
    handleGoBack() {
      this.updateManualTestStep('2');
      gtag('event', 'backClick', {
        event_label: 'go back',
        event_category: 'step3',
        value: 1,
      });
    },
    handleStartTest() {
      this.initiateSignalTest();
      this.loading = true;
      gtag('event', 'continueClick', {
        event_label: 'continue',
        event_category: 'step3',
        value: 1,
      });
    },
    ...mapActions(['initiateSignalTest']),
    ...mapMutations(['updateManualTestStep']),
  },
  watch: {
    isModalOpen() {
      if (this.isModalOpen) {
        this.loading = false;
      }
    },
  },
  components: {
    cbButton: Button,
  },
};
</script>

<style lang="scss" scoped>
.cb-setup-test-1 {
  &__body {
    .cb-heading-4 {
      margin-bottom: 12px;
    }
    &__warning {
      padding: 12px;
      width: fit-content;
      border: 1px solid $light-grey;
      border-radius: 5px;
      margin-top: 20px;

      strong {
        color: $red;
      }
    }
  }

  &__footer {
    margin-top: 40px;

    .cb-button {
      width: 100%;

      &--outline-blue {
        display: none;
      }
    }

    &__back-button {
      border: none;
      background-color: unset;
      position: absolute;
      top: 20px;
      left: 20px;
      padding: 0;
    }
  }

  @include desktop {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    &__body {
      flex-grow: 1;
      padding: 0 40px;

      .cb-heading-4 {
        font-size: 36px;
        line-height: 50px;
      }
    }

    &__footer {
      margin-top: 0;

      &__divider {
        display: block;
        height: 1px;
        background-color: $light-blue-grey;
        margin-bottom: 20px;
      }

      &__button-container {
        display: flex;
        justify-content: flex-end;

        .cb-button {
          width: auto;

          &--outline-blue {
            display: block;
            margin-right: 16px;
          }
        }
      }

      &__back-button {
        display: none;
      }
    }
  }
}
</style>
